import React from 'react';
import { Navigate, useParams, Outlet } from 'react-router-dom';
import PublicBackMethods from '../pages/PublicUsers/PublicBackMethods';

const PublicProtectedRoute = () => {
    const { accountToken, expiresAt, establishmentUid } = PublicBackMethods();
    const { id } = useParams();

    // فحص التاريخ بشكل آمن
    const isTokenExpired = expiresAt ? new Date() > new Date(expiresAt) : false;

    // 1. إذا لم يسجل دخول أو انتهت الصلاحية
    if (!accountToken || isTokenExpired) {
        return <Navigate to={`/public-dashboard/${id}`} replace />;
    }

    // 2. حماية الخصوصية: منع صاحب منشأة A من دخول لوحة تحكم منشأة B
    // نقارن الـ UID المخزن في المتصفح مع الـ ID الموجود في الرابط
    if (establishmentUid && id.toLowerCase() !== establishmentUid.toLowerCase()) {
        return <Navigate to={`/establishment-dashboard/${establishmentUid}`} replace />;
    }

    return <Outlet />;
};

export default PublicProtectedRoute;